import { useDispatch } from "react-redux";

import { Club } from "../../store/Session/SessionModel";
import sessionSlice from "../../store/Session/SessionSlice";

import "./style.css";

interface Props {
  club: Club;
}

const ToggleClub = ({ club }: Props): JSX.Element => {
  const dispatch = useDispatch();
  const lightenColor = (hex: string) => `${hex}80`;

  const setClubIsActive = (club: Club) => {
    dispatch(
      sessionSlice.actions.setClubIsActive({
        isActive: !club.isActive,
        clubId: club.clubId
      })
    );
  };

  return (
    <div
      className={`toggle-club club-toggle-${club.isActive}`}
      style={{
        backgroundColor: club.isActive
          ? lightenColor(club.clubColor)
          : "#60626980"
      }}
      onClick={() => setClubIsActive(club)}
    >
      <div
        className={`circle-club-color  ${
          !club.isActive ? "club-inactive" : "club-active"
        }`}
        style={{ backgroundColor: club.clubColor }}
      >
        <div className="club-icon">{club.clubIcon}</div>
      </div>
    </div>
  );
};

export default ToggleClub;
